export default {"src":"/_next/static/media/google.26110d0e.svg","height":36,"width":36,"blurWidth":0,"blurHeight":0};